/* eslint-disable */
require('./archive_box')
require('./archive_tray')
require('./arrow_bold')
require('./arrow_circle')
require('./arrow_long')
require('./arrow_square')
require('./arrow')
require('./at')
require('./award-blank')
require('./bank')
require('./below-water-en')
require('./below-water-ru')
require('./burger')
require('./business-meeting')
require('./calendar')
require('./caret_full')
require('./caret')
require('./check_circle')
require('./check_square')
require('./check')
require('./clean-energy-en')
require('./clean-energy-ru')
require('./clean-water-en')
require('./clean-water-ru')
require('./climate-action-en')
require('./climate-action-ru')
require('./clock')
require('./close_light')
require('./close_square')
require('./close')
require('./cloud-privacy')
require('./coal-export')
require('./coal-group')
require('./coal-icon')
require('./coal-mining-tower')
require('./coal-vagon')
require('./coal')
require('./conference')
require('./contacts')
require('./decent-work-en')
require('./decent-work-ru')
require('./document-check')
require('./domestic-market')
require('./dots_three')
require('./double_arrow')
require('./download')
require('./earth')
require('./eco-leaf')
require('./eco-shield')
require('./ecosystem')
require('./exchange-arrows')
require('./external')
require('./factory-wage')
require('./factory')
require('./fav-svg')
require('./file')
require('./freight')
require('./full-vagon')
require('./gear-cycle')
require('./gears')
require('./gender-equality-en')
require('./gender-equality-ru')
require('./globe')
require('./good-health-en')
require('./good-health-ru')
require('./google')
require('./group-of-workers')
require('./group-people')
require('./hat')
require('./house')
require('./ical')
require('./industry-innovation-en')
require('./industry-innovation-ru')
require('./information-hover')
require('./information-stroke')
require('./international')
require('./it')
require('./letter')
require('./link_small')
require('./link')
require('./lock')
require('./magnifying_glass')
require('./mail')
require('./meeting-people')
require('./mine-vagon')
require('./mini_arrow')
require('./mining-factory')
require('./mining')
require('./minus')
require('./no-poverty-en')
require('./no-poverty-ru')
require('./on-land-en')
require('./on-land-ru')
require('./outlook')
require('./paper_clip')
require('./paper-clip')
require('./partnership-goals-en')
require('./partnership-goals-ru')
require('./peace-justice-en')
require('./peace-justice-ru')
require('./people-group')
require('./personal')
require('./phone')
require('./photo')
require('./pin')
require('./play')
require('./plus')
require('./printer')
require('./progress-in-hand')
require('./projector')
require('./QR')
require('./quality-education-en')
require('./quality-education-ru')
require('./question')
require('./quote')
require('./reduced-inequalities-en')
require('./reduced-inequalities-ru')
require('./responsible-consumption-en')
require('./responsible-consumption-ru')
require('./russia')
require('./safety')
require('./sale')
require('./scale')
require('./search')
require('./sg-element')
require('./share')
require('./sitemap')
require('./snabjenie-1')
require('./snabjenie-2')
require('./snabjenie-3')
require('./snabjenie-4')
require('./social')
require('./supply')
require('./sustainable-cities-en')
require('./sustainable-cities-ru')
require('./sustainable-development-en')
require('./sustainable-development-ru')
require('./video')
require('./warning')
require('./windmill-fabric')
require('./work')
require('./worker-automatization')
require('./worker')
require('./world')
require('./wtite')
require('./zero-hunger-en')
require('./zero-hunger-ru')
